import { combineReducers } from 'redux';

import dns from './dns/dnsReducer';
import loadbalancer from './loadbalancer/reducer';
import util from './util/utilReducer';
import zone from './zone/zoneReducer';

export default combineReducers({
	dns,
	loadbalancer,
	util,
	zone,
});
